import { useState } from 'react'
import { api } from '@/lib/api'
import { Send } from 'lucide-react'

const CHANNELS = ['SMS', 'WHATSAPP', 'EMAIL', 'WEB_CHAT', 'IG_DM', 'FB_MSG'] as const

export function SimulatorPage() {
  const [channelKind, setChannelKind] = useState<(typeof CHANNELS)[number]>('WHATSAPP')
  const [fromIdentifier, setFromIdentifier] = useState('+34600000001')
  const [body, setBody] = useState('Hola, vengo de la web. ¿Podéis darme presupuesto?')
  const [busy, setBusy] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setResult(null)
    try {
      const r = await api<{ conversationId: string; messageId: string }>(
        '/v1/marketing/_simulator/inbound',
        {
          method: 'POST',
          body: JSON.stringify({ channelKind, fromIdentifier, body }),
        },
      )
      setResult(`OK · conversación ${r.conversationId.slice(0, 8)}…`)
    } catch (e) {
      setResult(`ERROR · ${e instanceof Error ? e.message : String(e)}`)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="p-6 max-w-2xl">
      <header className="mb-4">
        <h1 className="text-lg font-medium tracking-tight">Simulador de canales</h1>
        <p className="text-xs font-mono text-ink-700/60">
          Inyecta mensajes como si llegaran de un cliente real · sólo dev · ver decisión A3 del
          PLAN
        </p>
      </header>

      <form onSubmit={(e) => void submit(e)} className="bp-card p-4 space-y-3">
        <label className="block">
          <span className="text-xs font-mono uppercase tracking-wider text-ink-700/70">canal</span>
          <select
            className="mt-1 w-full border border-ink-900/15 rounded px-2 py-1.5 bg-white text-sm"
            value={channelKind}
            onChange={(e) => setChannelKind(e.target.value as (typeof CHANNELS)[number])}
          >
            {CHANNELS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="text-xs font-mono uppercase tracking-wider text-ink-700/70">
            from (E.164 / email / handle)
          </span>
          <input
            className="mt-1 w-full border border-ink-900/15 rounded px-2 py-1.5 bg-white text-sm font-mono"
            value={fromIdentifier}
            onChange={(e) => setFromIdentifier(e.target.value)}
            required
          />
        </label>

        <label className="block">
          <span className="text-xs font-mono uppercase tracking-wider text-ink-700/70">
            mensaje
          </span>
          <textarea
            className="mt-1 w-full border border-ink-900/15 rounded px-2 py-1.5 bg-white text-sm min-h-[100px]"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
          />
        </label>

        <div className="flex items-center justify-between">
          <button type="submit" className="bp-btn-primary" disabled={busy}>
            <Send className="size-3.5" />
            {busy ? 'Enviando…' : 'Inyectar mensaje'}
          </button>
          {result && (
            <span
              className={`text-xs font-mono ${
                result.startsWith('ERROR') ? 'text-red-700' : 'text-blueprint-700'
              }`}
            >
              {result}
            </span>
          )}
        </div>
      </form>
    </div>
  )
}
